<template>
    <DefaultNav/>
    <router-view/>
</template>

<script>
import DefaultNav from "@/components/Headers/DefaultNav";
export default {
    components: {
        DefaultNav
    }
};
</script>